import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import { Card, BarChart, Text } from '@tremor/react'

const data = [
  { local: 'Lacroze', porcentaje: 55 },
  { local: 'Nordelta', porcentaje: 100 },
  { local: 'Formosa', porcentaje: 82 },
  { local: 'Scalabrini', porcentaje: 82 },
  { local: 'Vuelta', porcentaje: 82 },
  { local: 'Gorostiaga', porcentaje: 82 },
  { local: 'Oroño', porcentaje: 82 },
  { local: 'Sinclair', porcentaje: 82 },
  { local: 'Arenales', porcentaje: 82 },
  { local: 'Paunero', porcentaje: 50 },
]

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const downloadCSV = () => {
  const csvRows = [['Local', 'Porcentaje'], ...data.map(row => [row.local, row.porcentaje])]
  const csvContent = csvRows.map(e => e.join(',')).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = 'tickets_por_app_por_local.csv'
  a.click()
  URL.revokeObjectURL(url)
}

export const TicketsByAppByStore = () => {
  const [view, setView] = useState<'chart' | 'table'>('chart')

  return (
    <Card className="p-8">
      <div className="flex flex-row justify-between items-start mb-6">
        <Text className="text-2xl font-bold" style={montserratStyle}>
          Tickets x APP (por local) de Enero 2025
        </Text>
        <div className="flex items-center gap-2">
          <div className="flex border rounded-lg overflow-hidden">
            <button
              type="button"
              className="px-4 py-2 font-bold"
              style={{
                ...montserratStyle,
                background: view === 'chart' ? '#232E2A' : '#FFF6F0',
                color: view === 'chart' ? '#fff' : '#232E2A',
              }}
              onClick={() => setView('chart')}
            >
              Gráfico
            </button>
            <button
              type="button"
              className="px-4 py-2 font-bold"
              style={{
                ...montserratStyle,
                background: view === 'table' ? '#232E2A' : '#FFF6F0',
                color: view === 'table' ? '#fff' : '#232E2A',
                borderLeft: '1px solid #232E2A',
              }}
              onClick={() => setView('table')}
            >
              Tabla
            </button>
          </div>
          <IconButton className="ml-2" aria-label="download" onClick={downloadCSV}>
            <GetAppIcon />
          </IconButton>
        </div>
      </div>
      <div id="bar-chart-locales" className="mt-4">
        {view === 'chart' ? (
          <BarChart
            data={data}
            index="local"
            categories={['porcentaje']}
            colors={['green']}
            valueFormatter={number => `${number}%`}
            showLegend={false}
            showGridLines
            yAxisWidth={40}
            minValue={0}
            maxValue={100}
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          />
        ) : (
          <table
            style={{
              width: '100%',
              fontFamily: 'Montserrat, sans-serif',
              color: '#1E1E1E',
              borderCollapse: 'collapse',
            }}
          >
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: 8, borderBottom: '2px solid #232E2A' }}>
                  Local
                </th>
                <th style={{ textAlign: 'left', padding: 8, borderBottom: '2px solid #232E2A' }}>
                  Porcentaje
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map(row => (
                <tr key={row.local}>
                  <td style={{ padding: 8, borderBottom: '1px solid #e5e7eb' }}>{row.local}</td>
                  <td style={{ padding: 8, borderBottom: '1px solid #e5e7eb' }}>
                    {row.porcentaje}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </Card>
  )
}
